import { Component } from '@angular/core';
import { FormControl, AbstractControl } from '@angular/forms'; // Importa AbstractControl se non è già importato
import { FieldType } from '@ngx-formly/core';
import { isObservable, map, of } from 'rxjs';

@Component({
  selector: 'formly-field-selectbutton',
  styleUrls: ['../../config-page/config-page.component.scss'],
  template: `
  <div class="form-group mt20">
    <div class="grid grid-flow-row-dense grid-cols-3 grid-rows-1">
      <div class="col-span-2">
        <strong><label *ngIf="to.label" class="form-label">{{ to.label }}</label></strong>
      </div>
      <div class="switch-align">
        <div class="switch-state-container">
          <mat-slide-toggle
            [formControl]="formControlTyped"
            [formlyAttributes]="field"
            color="primary">
          </mat-slide-toggle>
        </div>
      </div>
    </div>
  </div>
  <p-divider></p-divider>

`
})
export class FieldSelectButtonComponent extends FieldType {

  get formControlTyped(): FormControl {
    return this.formControl as FormControl;
  }

  get options$() {
    const opts = this.to.options;
    return isObservable(opts)
      ? opts.pipe(map((options: any[] | null) => options ?? []))
      : of(opts ?? []);
  }
}